import { ModuleRendering, SlotRendering } from '@frontend/common-types';
import { DefaultPrimaryButton, DefaultSecondaryButton, Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { SlotRendering as SlotTypesSlotRendering } from '@frontend/slot/types';
import { SpotRenderingClient } from '@frontend/spot/api';
import { FormattedMessage } from 'react-intl';

import { ChooseModuleModal } from '../../components/choose-module-modal/choose-module-modal.component';
import { KioskNavigationFooter } from '../../components/kiosk-navigation-footer.component';
import { KioskNavigationHeader } from '../../components/kiosk-navigation-header.component';
import { SpotLayout } from '../../spot-rendering';
import { useBulkMoveAssignSlots } from './bulk-move-assign-slots.controller';

const ID = 'bulk-move-assign-slots';

const BulkMoveAssignSlots = () => {
    const viewProps = useBulkMoveAssignSlots();
    const showMainContent = !viewProps.isLoading && !viewProps.error;

    return (
        <div
            id={ID}
            className='bg-background-default flex size-full flex-col overflow-hidden'>
            <KioskNavigationHeader
                title={CommonMessage.DETAIL.MANAGE(CommonMessage.OBJECTS.SPOT.DISTRI_SPOT)}
                onBack={viewProps.handleBack}
            />

            <div className='flex flex-1 flex-col items-center overflow-hidden p-6'>
                {viewProps.isLoading && <Spinner />}
                {viewProps.error && <div className='text-status-danger'>{viewProps.error}</div>}
                {showMainContent && (
                    <div className='flex size-full w-full flex-1 flex-col items-start gap-6 overflow-y-auto pb-4'>
                        <p className='text-foreground-default text-lg font-semibold'>
                            <FormattedMessage
                                id='kiosk.manage-spot.bulk-move-transactions.assign-slots.title'
                                defaultMessage='Select destination SLOT'
                                description='Title on the bulk move SLOT selection screen'
                            />
                        </p>

                        <div className='flex w-full flex-col items-center gap-4'>
                            {viewProps.currentModule && viewProps.accountId && viewProps.spotId && (
                                <div className='flex size-full max-w-md flex-row justify-center'>
                                    <SpotLayout<ModuleRendering, SlotRendering>
                                        key={viewProps.currentModule.id}
                                        renderMode='module'
                                        module={viewProps.currentModule}
                                        fetchSpotData={(arg) => SpotRenderingClient.fetchSpotRendering(viewProps.accountId!, viewProps.spotId!, arg)}
                                        fetchModuleData={(accountId, spotId, moduleId) =>
                                            SpotRenderingClient.fetchSpotModuleRendering(accountId, spotId, moduleId)
                                        }
                                        slot={{
                                            renderElement: (slot) =>
                                                viewProps.slotComponent({
                                                    ...slot,
                                                    slot_ids: [slot.id],
                                                    column_slot_ids: null
                                                } as unknown as SlotTypesSlotRendering)
                                        }}
                                        enableSlotHover={false}
                                        onModuleNameClick={() => viewProps.setSelectModuleModalOpen(true)}
                                        onSelectedModuleChange={(moduleId) => {
                                            const module = viewProps.modules?.find((m) => m.id === moduleId);
                                            if (module) viewProps.setCurrentModule(module);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            <KioskNavigationFooter
                leftButton={
                    <DefaultSecondaryButton
                        text={CommonMessage.BUTTONS.GO_BACK}
                        onClick={viewProps.handleBack}
                    />
                }
                rightButton={
                    <DefaultPrimaryButton
                        text={CommonMessage.BUTTONS.CONTINUE}
                        onClick={viewProps.handleContinue}
                        disabled={!viewProps.canContinue}
                    />
                }
            />

            {viewProps.modules && (
                <ChooseModuleModal
                    show={viewProps.selectModuleModalOpen}
                    onClose={() => viewProps.setSelectModuleModalOpen(false)}
                    modules={viewProps.modules}
                    currentModule={viewProps.currentModule}
                    onSelectModule={viewProps.setCurrentModule}
                />
            )}
        </div>
    );
};

export default BulkMoveAssignSlots;
